import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/img/special-for-you-icon.png'
import _imports_1 from '@/assets/img/gold-tier-badge-icon.svg'
import _imports_2 from '../../assets/img/arrow-circle-right-icon.png'


const _hoisted_1 = {
  key: 0,
  class: "free-coupon-section"
}
const _hoisted_2 = { class: "free-coupon-title-group" }
const _hoisted_3 = { class: "free-coupon-title-name" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "free-coupon-title-icon",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "arrow" }
const _hoisted_6 = { class: "free-coupon-items" }
const _hoisted_7 = { class: "free-coupon-detail-img" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "free-coupon-detail-group" }
const _hoisted_10 = { class: "free-coupon-detail-title" }
const _hoisted_11 = {
  key: 0,
  class: "gold-tier"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "gold-tier-badge",
  src: _imports_1
}, null, -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "free-coupon-detail-expire" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "free-coupon-section"
}
const _hoisted_18 = { class: "free-coupon-title-group" }
const _hoisted_19 = { class: "free-coupon-title-name" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  class: "free-coupon-title-icon",
  src: _imports_0
}, null, -1)
const _hoisted_21 = { class: "arrow" }
const _hoisted_22 = { class: "free-coupon-items" }
const _hoisted_23 = { class: "free-coupon-detail-img" }
const _hoisted_24 = { class: "free-coupon-detail-group" }
const _hoisted_25 = { class: "free-coupon-detail-title" }
const _hoisted_26 = { class: "free-coupon-detail-expire" }

export function render(_ctx, _cache) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_q_skeleton = _resolveComponent("q-skeleton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isLoading && _ctx.couponsList.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", null, _toDisplayString(_ctx.textTitleName), 1)
            ]),
            _createElementVNode("div", {
              class: "free-coupon-title-view-all",
              onClick: _cache[0] || (_cache[0] = $event => (_ctx.openModalCoupon()))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.textViewAll), 1),
              _createElementVNode("button", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_swiper, {
              slidesPerView: 'auto',
              spaceBetween: 8,
              freeMode: true,
              modules: _ctx.modules
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.couponsList, (coupon, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (index < 10)
                      ? (_openBlock(), _createBlock(_component_swiper_slide, {
                          key: 0,
                          class: "free-coupon-slide",
                          onClick: $event => (_ctx.openModalCoupon(coupon))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("img", {
                                src: _ctx.getImage(coupon.media.url),
                                onError: _cache[1] || (_cache[1] = (...args) => (_ctx.errorImage && _ctx.errorImage(...args)))
                              }, null, 40, _hoisted_8)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                (coupon.couponType.toLocaleLowerCase() === _ctx.textCouponTypeGold.toLocaleLowerCase())
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                      _hoisted_12,
                                      _createTextVNode(_toDisplayString(coupon.couponName), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(coupon.couponName), 1)),
                                _createElementVNode("span", {
                                  innerHTML: coupon.description
                                }, null, 8, _hoisted_14)
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", null, "หมดเขต " + _toDisplayString(_ctx.getExpiryDate(coupon.expiryDate)), 1)
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256)),
                (_ctx.couponsList.length >= 10)
                  ? (_openBlock(), _createBlock(_component_swiper_slide, {
                      key: 0,
                      class: "free-coupon-slide-view-all",
                      onClick: _cache[2] || (_cache[2] = $event => (_ctx.openModalCoupon()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(_ctx.textViewAll), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modules"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", null, _toDisplayString(_ctx.textTitleName), 1)
            ]),
            _createElementVNode("div", {
              class: "free-coupon-title-view-all",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.openModalCoupon()))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.textViewAll), 1),
              _createElementVNode("button", _hoisted_21, [
                _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-chevron-right" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_swiper, {
              slidesPerView: 'auto',
              spaceBetween: 8,
              freeMode: true,
              modules: _ctx.modules
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
                  return _createVNode(_component_swiper_slide, { class: "free-coupon-slide" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_q_skeleton, {
                          class: "skeleton-img",
                          width: "25.3vw",
                          height: "25.3vw"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_q_skeleton, {
                            class: "skeleton-title",
                            width: "38.2vw",
                            height: "4.3vw"
                          }),
                          _createVNode(_component_q_skeleton, {
                            class: "skeleton-title",
                            width: "24vw",
                            height: "4.3vw"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_q_skeleton, {
                            class: "skeleton-expire",
                            width: "24vw",
                            height: "4.3vw"
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  })
                }), 64))
              ]),
              _: 1
            }, 8, ["modules"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}